import { Close, ExpandMore, Folder, Save } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Grid, IconButton, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import Mapa from '../../componentes/mapa/Mapa';

const ActividadesTab = ({ actividades, imagenes, editable = false, handleUpdate, setData, setImgs }) => {

    const [catalogoActividades, setCatalogoActividades] = useState([]);
    const getCatalogo = async () => {

        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/catalogo_actividades`)
            .then((res) => res.json())
            .then((respuesta) => {
                setCatalogoActividades(respuesta.data);
            })
    }

    useEffect(() => {
        getCatalogo();
    }, []);

    const [giroSeleccionado, setGiroSeleccionado] = useState('');


    const [giroAbierto, setGiroAbierto] = useState(null);
    const handleOpenGiro = (codigo) => {
        giroAbierto != codigo ? setGiroAbierto(codigo) : setGiroAbierto(null);
    }

    const deleteGiro = (index) => {
        let newVal = actividades.filter((giro, i) => i != index);
        let e = { target: { value: newVal } };
        setData(e);
        if (giroAbierto == index) {
            setGiroAbierto(null);
        }
    }

    const addGiro = (e) => {
        if (!actividades.some((i) => i.giro_actividad == e.codigo_act)) {
            let act = catalogoActividades.find((i) => i.codigo_act == e.codigo_act)
            let newVal = [...actividades, { giro_actividad: act.codigo_act }];
            let ev = { target: { value: newVal } };
            setGiroAbierto(actividades.length);
            setData(ev);
        }
    }


    const handleInput = (e) => {
        let imagen = e.target.files[0] ?? null;
        if (imagen) {
            const reader = new FileReader();
            reader.onload = (readerEvent) => {
                imagen.dataurl = readerEvent.target.result;
                imagen.paso = 'actividades_economicas';
                setData({
                    target: { name: 'imagenes', value: [...imagenes, imagen] }
                });
            };
            reader.readAsDataURL(imagen);
        }
    };

    const removeImg = (imgurl, isNew = false) => {
        setData({ target: { name: 'imagenes', value: imagenes.filter(img => (isNew ? img.dataurl : img.url_img) !== imgurl) } });
    }


    if (actividades && catalogoActividades.length > 0) {
        return (
            <Box sx={{ m: 2 }}>
                <Grid container spacing={2}>
                    {/* Giros */}
                    <Grid item xs={12}>
                        <Typography variant="h6">Giros:</Typography>
                        {actividades.length > 0 && actividades.map((giro, index) => {
                            let datosGiro = catalogoActividades.find((cat) => cat.codigo_act == giro.giro_actividad);
                            return (
                                <Accordion key={datosGiro.giro_actividad} expanded={giroAbierto === index} onChange={() => handleOpenGiro(index)} sx={{ boxShadow: 2, borderRadius: 1, my: 1 }}>
                                    <AccordionSummary expandIcon={<ExpandMore />}>
                                        <Typography variant='body1' fontWeight='bold'>{datosGiro.nombre_act}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Typography sx={{ whiteSpace: 'pre-line' }} variant='body1'>{datosGiro.descripcion}</Typography>
                                        {/* incluye excluye */}
                                        <Grid container spacing={2} sx={{ my: 2 }}>
                                            <Grid item xs={6}>
                                                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                                                    <Typography fontWeight="bold">Incluye:</Typography>
                                                </Box>
                                                <Typography>{datosGiro.incluye}</Typography>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                                                    <Typography fontWeight="bold">Excluye:</Typography>
                                                </Box>
                                                <Typography>{datosGiro.excluye}</Typography>

                                            </Grid>
                                        </Grid>

                                        {editable &&
                                            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                <Button onClick={() => deleteGiro(index)} variant="contained" color="error">Eliminar giro</Button>
                                            </Box>
                                        }
                                    </AccordionDetails>
                                </Accordion>
                            )
                        })}
                        {/* En edicion, solo eliminar/agregar distintos giros */}
                        {editable &&
                            <Autocomplete
                                fullWidth
                                disableClearable
                                name="giro_actividad"
                                options={catalogoActividades}
                                getOptionLabel={(option) => option.nombre_act ?? ''}
                                value={giroSeleccionado}
                                onChange={(e, actividad) => {
                                    addGiro(actividad);
                                    setGiroSeleccionado(actividad.codigo_act);
                                }}
                                renderInput={params => (
                                    <TextField {...params} label="Agregar giro" />
                                )}
                            />
                        }
                    </Grid>

                    {/* Fotos */}
                    {!editable &&
                        <Grid item xs={12}>
                            <Typography variant="h6">Fotogalería:</Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                                {imagenes && Object.values(imagenes).filter(i => i.paso == 'actividades_economicas').map((imagen) => {
                                    return (
                                        <img src={imagen.url_img ?? imagen.dataurl} width="300px" alt={imagen.url_img ? imagen.url_img.split('/')[-1] : ''} />
                                    )
                                })
                                }
                            </Box>
                        </Grid>
                    }

                    {editable &&
                        <Grid item xs={12}>
                            <Grid container spacing={2} sx={{ mx: 2, mt: 2 }}>
                                {Object.values(imagenes).filter((i) => i.paso == 'actividades_economicas').map((image, index) => (
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        key={index}
                                        sx={{ position: 'relative', border: 1, borderColor: '#e0dcda', display: 'flex', alignItems: 'center' }}>
                                        <IconButton sx={{ color: '#ff4444', position: 'absolute', top: 0, right: 0 }} onClick={() => image.url_img ? removeImg(image.url_img) : removeImg(image.dataurl, true)}>
                                            <Close />
                                        </IconButton>
                                        <img src={image.url_img ?? image.dataurl} alt={image.name} width="300px" />
                                    </Grid>
                                ))}
                                <Grid item xs={12}>
                                    <Button
                                        disabled={imagenes.filter((i) => i.paso == 'actividades_economicas').length > 6}
                                        component="label"
                                        variant="contained"
                                        startIcon={<Folder />}
                                    >
                                        Agregar <input name="imagenes" onInputCapture={handleInput} type="file" accept='image/*' hidden />
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>

                    }
                    {editable &&
                        <Grid item xs={12}>
                            <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
                                <Button variant="contained" color="success" startIcon={<Save />} onClick={handleUpdate} >Guardar esta sección</Button>
                            </Box>
                        </Grid>
                    }
                </Grid>
            </Box>
        )
    }
}
export default ActividadesTab